<template>
  <div style="position: relative;"
       v-if="url">
    <v-img :src="url"
           :alt="alt"
           eager
           :width="width"
           :max-height="maxHeight"
           :options="intersectionOptions"
           style="border: 1px solid gray;"/>
    <file-type-icon v-if="showIcon"
                    :document="document"
                    style="position: absolute; top: 5px; right: 5px;">
    </file-type-icon>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import {isArray} from 'lodash';
import FileTypeIcon from './FileTypeIcon';

export default {
  components: {FileTypeIcon},
  props: {
    width: {
      type: String,
      default: '85',
    },
    maxHeight: {
      type: String,
      default: '110',
    },
    connection: {
      type: String,
      required: true,
    },
    document: {
      type: Object,
      required: true,
    },
    showIcon: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters([
      'team',
    ]),
    intersectionOptions() {
      // @see https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
      return {
        //threshold: 0,
      }
    },
    publicID() {
      return `teams/${this.team.code}/vault/${this.team.vault_connection_id}/${this.document.id}_${this.document.major_version_number__v}_${this.document.minor_version_number__v}`
    },
    alt() {
      return `Document ${this.document.id}`;
    },
    isDemo() { // MLD-2944
      return this.connection === 'demo_vault';
    },
    thumbnails() {
      return isArray(this.document.thumbnails)
        ? this.document.thumbnails
        : [];
    },
    url() {
      if (!this.isDemo && this.thumbnails.length > 0) {
        return this.document.thumbnails[0].url;
      }
      return '/images/placeholder_170x220.png';
      //return `https://via.placeholder.com/${this.width}x${this.maxHeight}?text=FPO`;
      //return `https://res.cloudinary.com/mobilelocker/image/upload/v1618291154/${this.publicID}.jpg`
      //return `/proxy/veeva/vault/${this.connection}/objects/documents/${this.document.id}/versions/${this.document.major_version_number__v}/${this.document.minor_version_number__v}/thumbnail`;
    }
  }
}
</script>
